export default function IconAge() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="uuid-832f92bd-0635-427e-8c59-63dd2733f1e3"
      data-name="Layer 2"
      viewBox="0 0 60 60"
    >
      <defs>
        <style>
          {
            ".uuid-07b84ea2-fcb2-485f-b3f7-1fc7dce54d37{fill:var(--color-primary(-alpha(-light)));stroke-width:0}"
          }
        </style>
      </defs>
      <g id="uuid-af862066-437b-477c-9dcf-01353cc82254" data-name="Layer 1">
        <path
          d="M51.213 8.787C45.547 3.12 38.013 0 30 0S14.453 3.12 8.787 8.787C3.12 14.453 0 21.987 0 30s3.12 15.547 8.787 21.213C14.453 56.88 21.987 60 30 60s15.547-3.12 21.213-8.787C56.88 45.547 60 38.013 60 30s-3.12-15.547-8.787-21.213ZM30 56.47C15.404 56.47 3.53 44.596 3.53 30S15.403 3.53 30 3.53 56.47 15.403 56.47 30 44.597 56.47 30 56.47Z"
          className="uuid-07b84ea2-fcb2-485f-b3f7-1fc7dce54d37"
        />
        <path
          d="M41.486 20.294c-2.287 0-5.06 1.44-8.473 4.403A48.257 48.257 0 0 0 30 27.562a48.261 48.261 0 0 0-3.013-2.865c-3.413-2.963-6.185-4.403-8.473-4.403-5.352 0-9.706 4.354-9.706 9.706s4.354 9.706 9.706 9.706c2.288 0 5.06-1.44 8.473-4.403A48.206 48.206 0 0 0 30 32.438c.75.777 1.805 1.817 3.013 2.865 3.414 2.963 6.186 4.403 8.473 4.403 5.352 0 9.706-4.354 9.706-9.706s-4.354-9.706-9.706-9.706ZM18.514 36.177c-3.406 0-6.177-2.771-6.177-6.177s2.771-6.176 6.177-6.176c2.166 0 6.188 3.307 8.947 6.177-2.757 2.869-6.777 6.176-8.947 6.176Zm22.972 0c-2.165 0-6.188-3.308-8.947-6.178 2.757-2.87 6.777-6.175 8.947-6.175 3.406 0 6.177 2.77 6.177 6.176s-2.77 6.177-6.177 6.177Z"
          className="uuid-07b84ea2-fcb2-485f-b3f7-1fc7dce54d37"
        />
      </g>
    </svg>
  );
}
